import RotatingText from './components/RotatingText';
import { useContactForm } from './hooks/useContactForm';
import './ContactScreen.css';

function ContactScreen() {
  const { formData, status, handleChange, handleSubmit } = useContactForm();

  const onSubmit = async (e) => {
    const result = await handleSubmit(e);
    
    if (result.success) {
      alert('Messaggio inviato! Ti risponderemo al più presto.');
    } else {
      alert('Si è verificato un errore durante l\'invio. Riprova più tardi.');
    }
  };

  const statements = [
    "Proponici idee e progetti",
    "Entra a far parte della Consulta",
    "Scopri i nostri eventi",
    "Partecipa alle iniziative"
  ];

  return (
    <div className="contact-screen">
      <section className="contact-hero">
        <h1>Contattaci</h1>
        <p>Siamo qui per ascoltarti</p>
      </section>

      <section className="contact-content">
        <div className="contact-container">
          <div className="contact-left">
            <div className="contact-info">
              <h2>Informazioni di Contatto</h2>
              <div className="info-item">
                <h3>📧 Email istituzionale</h3>
                <p>consultagiovanile@comune.ortona.ch.it</p>
              </div>
              <div className="info-item">
                <h3>📧 Email rapida</h3>
                <p>consultagiovanileortona@gmail.com</p>
              </div>
              <div className="info-item">
                <h3>📍 Indirizzo</h3>
                <p>Piazza San Giuseppe, 1<br />66026 Ortona (CH)</p>
              </div>
            </div>
            <div className="rotating-text-card">
              <RotatingText
                statements={statements}
                interval={3000}
                className="contact-rotating-text"
              />
            </div>
          </div>

          <div className="contact-form-container">
            <h2>Inviaci un Messaggio</h2>
            
            {status.success && (
              <div className="alert alert-success">
                Messaggio inviato con successo! Ti risponderemo al più presto.
              </div>
            )}
            
            {status.error && (
              <div className="alert alert-error">
                {status.error}
              </div>
            )}
            
            <form onSubmit={onSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name">Nome *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  disabled={status.loading}
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  disabled={status.loading}
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject">Oggetto *</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  disabled={status.loading}
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Messaggio *</label>
                <textarea
                  id="message"
                  name="message"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  disabled={status.loading}
                ></textarea>
              </div>

              <button 
                type="submit" 
                className="submit-button"
                disabled={status.loading}
              >
                {status.loading ? 'Invio in corso...' : 'Invia Messaggio'}
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ContactScreen;
